import CookiesNoticeAdapter from "./CookiesNoticeAdapter";

export default CookiesNoticeAdapter;
